var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
import { neutral60opacity05, neutral60opacity10 } from '../../../colors/neutral';
import { treeItemClasses } from '@mui/lab/TreeItem';
import { listStyles } from '../components/MuiListItem';
import { rem } from '../../../utils/rem';
export var MuiTreeView = {
    styleOverrides: {
        root: (_a = {},
            _a["& .".concat(treeItemClasses.root)] = (_b = {},
                _b["& .".concat(treeItemClasses.group)] = {
                    marginInlineStart: rem(24),
                },
                _b["& .".concat(treeItemClasses.content)] = (_c = {
                        minHeight: rem(34)
                    },
                    _c["&.".concat(treeItemClasses.focused)] = {
                        outline: listStyles.focusVisible.outline,
                        backgroundColor: listStyles.focusVisible.backgroundColor,
                    },
                    _c["&:hover"] = {
                        backgroundColor: listStyles.hover.backgroundColor,
                    },
                    _c["&.".concat(treeItemClasses.selected)] = {
                        backgroundColor: listStyles.selected.backgroundColor,
                        '&:hover': {
                            backgroundColor: listStyles.selectedHover.backgroundColor,
                        },
                    },
                    _c),
                _b),
            _a),
    },
    customOverrides: {
        small: (_d = {},
            _d["& .".concat(treeItemClasses.root)] = (_e = {},
                _e["& .".concat(treeItemClasses.content)] = (_f = {
                        borderBottom: 0,
                        minHeight: rem(28)
                    },
                    _f["& .".concat(treeItemClasses.label)] = (_g = {},
                        _g['& .MuiTreeItemLabel-text'] = {
                            fontSize: '0.775rem',
                        },
                        _g['& .MuiTreeItemLabel-icon'] = { marginInlineEnd: 8 },
                        _g),
                    _f),
                _e),
            _d),
        large: (_h = {},
            _h["& .".concat(treeItemClasses.root)] = (_j = {},
                _j["& .".concat(treeItemClasses.content)] = (_k = {
                        minHeight: rem(40)
                    },
                    _k["& .".concat(treeItemClasses.label)] = (_l = {},
                        _l['& .MuiTreeItemLabel-text'] = {
                            fontSize: '1rem',
                        },
                        _l),
                    _k),
                _j),
            _h),
        filled: (_m = {},
            // Only root has a background color set to filled
            _m["& > li.".concat(treeItemClasses.root, " > .").concat(treeItemClasses.content, ":not(.").concat(treeItemClasses.selected, ")")] = {
                backgroundColor: neutral60opacity05,
                '&:hover': {
                    backgroundColor: listStyles.hover.backgroundColor,
                },
            },
            _m),
        bordered: (_o = {},
            _o["& .".concat(treeItemClasses.root)] = (_p = {},
                _p["& .".concat(treeItemClasses.content)] = {
                    borderBottom: "".concat(rem(1), " solid ").concat(neutral60opacity10),
                },
                _p),
            _o),
    },
};
